import IBuildingFrontage = ZoningAPI.IBuildingFrontage;
import { getPrettyFrontageType } from '../enums/building-frontage-type';
import { ClonableItem } from './clonable-item';

export class BuildingFrontage extends ClonableItem<IBuildingFrontage> implements IBuildingFrontage {
    Id: number;
    Label: string;
    FrontageType: number;
    RoadIndex?: number;
    Setback?: number;
    MinThoroughfareWidth?: number;
    SegmentsIndexes?: number[];
    SegmentsLengths?: number[];

    constructor(value?: IBuildingFrontage) {
        super(value);
    }

    public get frontageTypeStr() {
        return getPrettyFrontageType(this.FrontageType);
    }
}
